 <template>
  <div>
  </div>
</template>

<script>
import { VueReCaptcha } from 'vue-recaptcha-v3'
import Vue from 'vue'
// For more options see below
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_CAPTCHA })

export default {
  data () {
    return {
      sitekey: process.env.VUE_APP_CAPTCHA,
      widgetId: 0
    }
  },
 
  methods: {
    async execute () {
    
      await this.$recaptchaLoaded()

      const token = await this.$recaptcha();
     
      // emit an event called verify with the response as payload
      this.$emit('verify', token);
      return token;
    }, 
  }, 
}
</script>